import { FC } from 'react';
import { BatteryBlock } from './BatteryBlock';
import type { Battery } from '@/hooks/useBatteryContainers';

interface BatteryRowProps {
  batteries: Battery[];
  powerKw: number;
  allocations?: Map<string, string>;
  onAllocate?: (battery: Battery) => void;
  onEdit?: (battery: Battery) => void;
  onDelete?: (battery: Battery) => void;
}

export const BatteryRow: FC<BatteryRowProps> = ({
  batteries,
  powerKw,
  allocations,
  onAllocate,
  onEdit,
  onDelete
}) => {
  const filteredBatteries = batteries.filter(b => b.power_kw === powerKw);

  if (filteredBatteries.length === 0) return null;

  return (
    <div className="space-y-2">
      <div className="text-sm font-medium text-muted-foreground">
        {powerKw}kW Batterijen ({filteredBatteries.length})
      </div>
      <div className="flex flex-wrap gap-3 p-2">
        {filteredBatteries.map((battery) => (
          <BatteryBlock
            key={battery.id}
            battery={battery}
            position={0}
            allocatedTo={allocations?.get(battery.id)}
            onAllocate={onAllocate ? () => onAllocate(battery) : undefined}
            onEdit={onEdit ? () => onEdit(battery) : undefined}
            onDelete={onDelete ? () => onDelete(battery) : undefined}
            isDouble={battery.capacity_kwh === 200}
          />
        ))}
      </div>
    </div>
  );
};
